import React from "react";
import { Close } from "shared/assets/icons";

import { Modal, ModalProps, Map, MapProps } from "shared/components";
import { Icon } from "shared/styles";
import { borderRadius } from "shared/styles/constants";
import { ITheme } from "shared/types";
import { MapModalContent, CloseMapButton } from "./styles";

interface MapModalProps extends MapProps, ModalProps {
  handleClose: () => void;
}

export const MapModal: React.FC<MapModalProps> = ({ handleClose, zoom = 14, ...props }) => (
  <Modal {...props} handleClose={handleClose} isFullscreen hideMargins showCloseButton={false}>
    <MapModalContent>
      <CloseMapButton onClick={handleClose} theme={ITheme.tertiary}>
        <Icon as={Close} />
      </CloseMapButton>
      <Map {...props} zoom={zoom} borderRadius={borderRadius.m} navigationPosition="bottom-right" />
    </MapModalContent>
  </Modal>
);
